import { useState} from "react";
import JSZip from "jszip";
import { useAnalytics } from "../hooks/useAnalytics";
import Sidebar from "./Sidebar/Sidebar";
import { useRef } from "react";
import {
  normalizeZipUrl,
  buildTree,
} from "../hooks/useZipLoader";
import EmptyView from "./Preview/EmptyView";
import TextPreview from "./Preview/TextPreview";
import ImagePreview from "./Preview/ImagePreview";
import PdfViewer from "./Preview/PdfViewer";
import VideoPreview from "./Preview/VideoPreview";
import AudioPreview from "./Preview/AudioPreview";
import DocxPreview from "./Preview/DocxPreview";
import UnsupportedPreview from "./Preview/UnsupportedPreview";
import Draggable from "react-draggable";






/* -------------------- MAIN COMPONENT -------------------- */

function ZipTreePreview() {
  const [zipUrl, setZipUrl] = useState("");
  const [tree, setTree] = useState({});
  const [zipRef, setZipRef] = useState(null);
  const [preview, setPreview] = useState(null);
  const [showInput, setShowInput] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [numPages, setNumPages] = useState(0);
  const [scale, setScale] = useState(1);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [zipMeta, setZipMeta] = useState(null);
  const analytics = useAnalytics();
  const buttRef=useRef(null);



  /* -------------------- ZIP LOADING -------------------- */

  const loadZipFromUrl = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/proxy-zip?url=${encodeURIComponent(
        normalizeZipUrl(zipUrl)
      )}`
    );

    if (!res.ok) return alert("Failed to load ZIP");

    const blob = await res.blob();
    const zip = await JSZip.loadAsync(blob);
    const tree = buildTree(zip);
    setTree(tree);
    setShowInput(false);
    setZipRef(zip);
    setPreview(null);

    /* -------- zip.info.json ALIGNMENT -------- */

    let meta;

    // if (zip.files["zip.info.json"]) {
      if(!(2>1)){
      const info = JSON.parse(await zip.files["zip.info.json"].async("text"));
      meta = {
        zip_id: info.zip_id,
        creator_id: info?.creator?.id || null,
        verified: true,
        file_count: info.file_count,
        types: info.types,
        name: info.name,
      };
    } else {
      meta = {
        zip_id: crypto.randomUUID(),
        creator_id: null,
        verified: false,
      };
    }
    // fetch(`${process.env.REACT_APP_API_BASE_URL}/zip/opened`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     zip_id: meta.zip_id,
    //     creator_id: meta.creator_id,
    //     verified: meta.verified,
    //     file_count: meta.file_count,
    //     types: meta.types,
    //     name: meta.name,
    //   }),
    // }).catch((err) => {
    //   console.error("zip/opened failed:", err.message);
    // });

    setZipMeta(meta);

    // analytics.track({
    //   event_type: "zip_opened",
    //   zip_id: meta.zip_id,
    //   creator_id: meta.creator_id,
    //   verified: meta.verified,
    //   metadata: {
    //     file_count: meta.file_count,
    //     types: meta.types,
    //   },
    // });
  };

  /* -------------------- FILE PREVIEW -------------------- */

  const handleFileClick = async (node) => {
    if (!node.isFile || !zipRef || !zipMeta) return;

    // if (preview?.filePath) {
    //   analytics.track({
    //     event_type: "file_closed",
    //     zip_id: zipMeta.zip_id,
    //     creator_id: zipMeta.creator_id,
    //     verified: zipMeta.verified,
    //     file_path: preview.filePath,
    //   });
    // }

    // analytics.track({
    //   event_type: "file_opened",
    //   zip_id: zipMeta.zip_id,
    //   creator_id: zipMeta.creator_id,
    //   verified: zipMeta.verified,
    //   file_path: node.path,
    // });



// cleanup old blob
if (preview?.data && typeof preview.data === "string") {
  URL.revokeObjectURL(preview.data);
}

const file = zipRef.files[node.path];
const ext = node.path.split(".").pop().toLowerCase();

if (["png", "jpg", "jpeg", "webp"].includes(ext)) {
  const blob = await file.async("blob");
  setPreview({
    type: "image",
    data: URL.createObjectURL(blob),
    filePath: node.path,
  });

} else if (ext === "pdf") {
  const blob = await file.async("blob");
  setPreview({
    type: "pdf",
    data: URL.createObjectURL(blob),
    filePath: node.path,
  });

} else if (["mp4", "webm", "ogg"].includes(ext)) {
  const blob = await file.async("blob");
  setPreview({
    type: "video",
    data: URL.createObjectURL(blob),
    filePath: node.path,
  });

} else if (["mp3", "wav", "m4a"].includes(ext)) {
  const blob = await file.async("blob");
  setPreview({
    type: "audio",
    data: URL.createObjectURL(blob),
    filePath: node.path,
  });

} else if (ext === "docx") {
  const buffer = await file.async("arraybuffer");
  setPreview({
    type: "docx",
    data: buffer,
    filePath: node.path,
  });

} else if (["txt", "md", "json", "js", "css", "html","java","py","c","cpp","go"].includes(ext)) {
  const text = await file.async("text");
  setPreview({
    type: "text",
    data: text,
    filePath: node.path,
  });
}
else {
  setPreview({
    type: "unsupported",
    ext,
    filePath: node.path,
  });
}
  };

  /* -------------------- FOCUS TRACKING -------------------- */

  // useEffect(() => {
  //   if (!preview?.filePath || !zipMeta) return;

  //   // const onFocus = () =>
  //   //   analytics.track({
  //   //     event_type: "focus_gained",
  //   //     zip_id: zipMeta.zip_id,
  //   //     creator_id: zipMeta.creator_id,
  //   //     verified: zipMeta.verified,
  //   //     file_path: preview.filePath,
  //   //   });

  //   // const onBlur = () =>
  //   //   analytics.track({
  //   //     event_type: "focus_lost",
  //   //     zip_id: zipMeta.zip_id,
  //   //     creator_id: zipMeta.creator_id,
  //   //     verified: zipMeta.verified,
  //   //     file_path: preview.filePath,
  //   //   });

  //   // window.addEventListener("focus", onFocus);
  //   // window.addEventListener("blur", onBlur);

  //   return () => {
  //     window.removeEventListener("focus", onFocus);
  //     window.removeEventListener("blur", onBlur);
  //   };
  // }, [preview, zipMeta, analytics]);

  /* -------------------- PDF -------------------- */

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  /* -------------------- RENDER -------------------- */

  return (
    <div className="app">
      {sidebarOpen && (
        <Sidebar
          zipRef={zipRef}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          showInput={showInput}
          zipUrl={zipUrl}
          setZipUrl={setZipUrl}
          loadZipFromUrl={loadZipFromUrl}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          tree={tree}
          onFileClick={handleFileClick}
        />
      )}


{!sidebarOpen && (
  <Draggable nodeRef={buttRef} allowMobileScroll={true}>
  <div
    ref={buttRef}
    className="drag-hitbox"
    onClick={() => setSidebarOpen(true)}
  >
    <span className="hamburger">☰</span>
  </div>
</Draggable>



)}


<main className="preview">
  {!preview && <EmptyView />}

  {preview?.type === "text" && (
    <TextPreview preview={preview} />
  )}

  {preview?.type === "image" && (
    <ImagePreview preview={preview} />
  )}

  {preview?.type === "pdf" && (
    <PdfViewer
      preview={preview}
      zipMeta={zipMeta}
      analytics={analytics}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      numPages={numPages}
      scale={scale}
      setScale={setScale}
    />
  )}

  {preview?.type === "video" && (
    <VideoPreview preview={preview} />
  )}

  {preview?.type === "audio" && (
    <AudioPreview preview={preview} />
  )}

  {preview?.type === "docx" && (
    <DocxPreview preview={preview} />
  )}

  {preview?.type === "unsupported" && (
    <UnsupportedPreview preview={preview} />
  )}
  {preview && preview.type !== "pdf" && (
  <div className="preview-inline-ad hide-this">
    <div className="ad-placeholder">
      Sponsored
    </div>
  </div>
)}
</main>
    </div>
  );
}

export default ZipTreePreview;
